module.exports = __webpack_public_path__ + "static/img/stamp.093462cc.png";